import { createContext } from 'react';
import type {
  NavigationContainerRefWithCurrent,
  ParamListBase,
} from '@react-navigation/native';

import type {
  Customer,
  FeatureFlagChangeListener,
  FeatureFlagOverrides,
  FeatureFlags,
} from './types';

// ─────────────────────────────────────────────────────────────────────────────

export const LaunchDarklyContext = createContext<
  LaunchDarklyContextType | undefined
>(undefined);

// ─── Types ───────────────────────────────────────────────────────────────────

export type LaunchDarklyContextType = {
  readonly defaults: FeatureFlags;
  readonly overrides: FeatureFlagOverrides;
  readonly initialFeatureFlags: FeatureFlags | undefined;
  readonly isReady: boolean;

  // ─────────────────────────────────────────────

  readonly init: (customer?: Customer) => Promise<void>;
  readonly identifyCustomer: (
    customer: Customer,
  ) => Promise<unknown> | undefined;
  readonly resetCustomer: () => Promise<void>;
  readonly registerFeatureFlagListener: FeatureFlagChangeListener;
  readonly unregisterFeatureFlagListener: FeatureFlagChangeListener;
  readonly close: () => Promise<void>;
  readonly removeQueryOverrides: (
    navigationContainerRef: NavigationContainerRefWithCurrent<ParamListBase>,
  ) => void;
};
